import React from 'react';
import { Box, Typography } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';
import { appColors } from '../../Config/Theme';

const WorkingTogetherBanner: React.FC = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      bgcolor: appColors.primary.light,
      border: `1px solid ${appColors.border.default}`,
      borderRadius: '12px',
      px: 2.5,
      py: 2,
      mt: 3,
    }}
  >
    <InfoIcon sx={{ color: appColors.primary.main, fontSize: 28 }} />
    <Box sx={{ flex: 1 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 700, color: appColors.text.heading, mb: 0.25 }}>
        Working together
      </Typography>
      <Typography variant="body2" sx={{ color: appColors.text.body }}>
        All headcounters update the same roster in real time. Changes sync automatically.
      </Typography>
    </Box>
    {/* Decorative people icons */}
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
      <Box sx={{ width: 36, height: 36, borderRadius: '50%', bgcolor: appColors.primary.main, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography sx={{ color: '#fff', fontSize: 16 }}>👤</Typography>
      </Box>
      <Typography sx={{ color: appColors.text.placeholder, fontSize: 14 }}>⇄</Typography>
      <Box sx={{ width: 36, height: 36, borderRadius: '50%', bgcolor: appColors.surface.inactive, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography sx={{ fontSize: 16 }}>👤</Typography>
      </Box>
    </Box>
  </Box>
);

export default WorkingTogetherBanner;
